import {Component, Input, OnInit} from '@angular/core';
import {TilesService} from "../../core";

@Component({
    selector: 'signal-strength',
    templateUrl: './signal-strength.component.html',
    styleUrls: ['./signal-strength.component.scss']
})
export class SignalStrengthComponent implements OnInit {
    @Input() value: number;
    circlePath1: string;
    circlePath2: string;
    circlePath3: string;

    constructor(
        private tiles: TilesService,
    ) {
    }

    ngOnInit() {
        this.circlePath1 = this.tiles.calculateCirclePoints(
            25, 25, 11, 0, 122, 4).toString();
        this.circlePath2 = this.tiles.calculateCirclePoints(
            25, 25, 18, 0, 126, 4).toString();
        this.circlePath3 = this.tiles.calculateCirclePoints(
            25, 25, 25, 0, 130, 4).toString();
    }
}
